import { useState } from "react";
import { Tooltip } from "reactstrap";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

const processMultiType = index => {
  if(index === 0) {
    return 'OK';
  } else if (index === 1) {
    return 'Warnings';
  } else if (index === 2) {
    return 'Alerts';
  } else {
    console.error('Failed to process type');
  }
};

function SummaryTooltip(data) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { values, index } = data;

  return (
    <Tooltip
      isOpen={tooltipOpen}
      target={`multiBar${index}`}
      toggle={() => setTooltipOpen(!tooltipOpen)}
    >
      {`${processMultiType(index)}: ${values[index]}`}
    </Tooltip>
  )
}
export default withErrorBoundary(SummaryTooltip, GeneralErrorBoundary);